import { defineComponent as _defineComponent } from 'vue'
import ContactFilter from '@/grpc-api/model/contact-filter';
import { computed, PropType } from 'vue';
import { TranslateResult } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactFilterSelect',
  props: {
  filters: { type: Array as PropType<Array<ContactFilter>>, required: true },
  value: { type: Object as PropType<undefined|null|ContactFilter>, required: true },
  allowEdit: { type: Boolean as PropType<boolean>, required: false, default: false },
  errorMessages: { type: Array as PropType<Array<String>>, required: false, default: () => [] },
},
  emits: ['input', 'add-filter', 'edit-filter', 'duplicate-filter', 'click:append-outer'],
  setup(__props, { emit }) {

const props = __props;



const isFilter = computed(() => props.value !== null && props.value !== undefined);

const canEditFilter = computed(() => props.value?.isDefault === false);

const defaultFilters = computed(() => props.filters.filter((f) => f.isDefault === true));

const customFilters = computed(() => props.filters.filter((f) => f.isDefault === false));

const contactFilters = computed(() => {
  const noDevider = defaultFilters.value.length === 0 || customFilters.value.length === 0;
  if (noDevider) return [...defaultFilters.value, ...customFilters.value];
  return [
    ...defaultFilters.value,
    { divider: true },
    ...customFilters.value,
  ];
});



const input = (value: ContactFilter) => {
  emit('input', value);
};

const add = () => {
  emit('add-filter');
};

const edit = () => {
  emit('edit-filter');
};

const duplicate = () => {
  emit('duplicate-filter');
};

const clickAppendOuter = () => {
  emit('click:append-outer');
};


return { __sfc: true,props, isFilter, canEditFilter, defaultFilters, customFilters, contactFilters, emit, input, add, edit, duplicate, clickAppendOuter }
}

})